<template>
  <v-text-field
    v-model="updatedText"
    :disabled="isDisabled"
    outlined
    hide-details
    @blur="onBlur"
    placeholder="hh:mm"
    v-mask="'##:##'"
    :height="height"
    background-color="white"
  ></v-text-field>
</template>

<script>
import { mask } from "vue-the-mask";
import { TimePickerComponent } from "@syncfusion/ej2-vue-calendars";

export default {
  name: "TimeInput",
  directives: { mask },
  props: {
    value: {
      type: String,
      default: "",
    },
    isTimerRunning: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    "ejs-timepicker": TimePickerComponent,
  },
  data() {
    return {
      height: 30,
      timeVal: new Date(),
      timeTest: "",
      updatedText: "",
      timeFormat: "HH:mm",
      timeStep: 60,
      dropdownVisible: false,
    };
  },
  mounted() {
    this.updatedText = this.value;
  },
  watch: {
    text(value) {
      this.updatedText = value;
    },
  },
  computed: {
    text() {
      return this.value;
    },
    isDisabled() {
      return this.isTimerRunning;
    },
  },
  methods: {
    onBlur,
  },
};

function onBlur(event) {
  const value = event.currentTarget.value;
  if (value !== "" && isValidTime(value)) {
    this.$emit("input", value || "");
  } else {
    this.updatedText = this.value;
  }
  this.$emit("edit", true);
}

function isValidTime(timeStr) {
  // Regular expression for matching "HH:mm" format
  const timeRegex = /^([01]\d|2[0-3]):?([0-5]\d)$/;

  // Check if the time string matches the format
  if (!timeRegex.test(timeStr)) {
    return false;
  }

  // Extract hours and minutes
  const [hours, minutes] = timeStr.split(":").map(Number);

  // Check if hours and minutes are within valid ranges
  if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
    return false;
  }

  return true;
}
</script>

<style scoped>
::v-deep.v-text-field .v-input__control .v-input__slot {
  min-height: 30px !important;
  display: flex !important;
  align-items: center !important;
  font-size: 14px;
}
</style>